export const SUBFLOW_ID_LIST_RECORDS = 'own_100f5064.6f140';
export const SUBFLOW_ID_RETRIEVE_RECORD = 'own_d51109f.3b25d';
export const SUBFLOW_ID_CREATE_RECORD = 'own_1d6d336a.9126c';
export const SUBFLOW_ID_REPLACE_RECORD = 'own_21057d66.1a85e';
export const SUBFLOW_ID_DELETE_RECORD = 'own_8fe6bea6.1072';
export const SUBFLOW_ID_SET_DATA_REFERENCE = 'own_105ec0bb.2f7d7';
export const SUBFLOW_ID_DELAY = 'own_97b54227.3b127';
export const LIST_RECORDS_SUBFLOW_SUCCESS_RESPONSE_KEY = 'records';
export const RETRIEVE_RECORD_SUBFLOW_SUCCESS_RESPONSE_KEY = 'record';
export const CREATE_RECORD_SUBFLOW_SUCCESS_RESPONSE_KEY = 'response';
export const REPLACE_RECORD_SUBFLOW_SUCCESS_RESPONSE_KEY = 'response';
export const DELETE_RECORD_SUBFLOW_SUCCESS_RESPONSE_KEY = 'response';
export const LEGACY_SUBFLOW_ID_SET_DATA_COLLECTION_REFERENCE = 'own_674f30b5.dc8f7';
export const LEGACY_SUBFLOW_ID_SET_DATA_REFERENCE = 'own_de046f0b.60038';
export const LEGACY_SUBFLOW_ID_LIST_RECORDS = 'own_15ff4942.264d07';
export const LEGACY_SUBFLOW_ID_RETRIEVE_RECORD = 'own_4e7d0a8d.c5e9c4';
export const LEGACY_SUBFLOW_ID_INITIALIZE_DATA_RECORD = 'own_ee594a3c.c75a88';
export const SUBFLOW_ID_OPEN_PAGE = 'own_2277ac59.912ff';
export const SUBFLOW_ID_SET_PAGE_VARIABLE = 'own_23268044.e1e2b';
export const SUBFLOW_CONFIRM_DIALOG = 'own_1adc86bb.3d695';
export const SUBFLOW_ALERT_DIALOG = 'own_bd0c25ba.5aaf3';
export const SUBFLOW_IF_CONDITION = 'own_225eb957.12fbd';
export const SUBFLOW_NAVIGATE_BACK = 'own_20bb6b4f.8c11d';
export const SUBFLOW_DEBOUNCE = 'own_14e7d132.5f02e';
